import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/Service/auth.service';
import { LoadingService } from 'src/app/Service/loading.service';
import { UserService } from 'src/app/User/Service/user.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['../../../Pages/landing/landing.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  classToggled = false;

  public toggleField() {
    this.classToggled = !this.classToggled;
  }

  @ViewChild('pricing') pricing;

  constructor(
    public auth: AuthService,
    public userService: UserService,
    private loader: LoadingService,
    private modalService: NgbModal,
    public route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    try {
      this.loader.HideLoading();
    } catch (error) {
      console.error('An error occurred in ngOnInit:', error);
    }
  }

  showPricing() {
    try {
      this.modalService.open(this.pricing, {
        centered: true,
        backdrop: 'static',
        keyboard: false,
      });
    } catch (error) {
      console.error('An error occurred in showPricing:', error);
    }
  }

  onClose() {
    try {
      this.modalService.dismissAll();
    } catch (error) {
      console.error('An error occurred in onClose:', error);
    }
  }

  // Check the scroll position and add/remove the class accordingly added by vinod
  isScrolled: boolean = false;
 
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 0;
  }
  
}
